/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobPartsArray } from "./JobPartsArray";
export const JobParts = core.serialization.undiscriminatedUnion([core.serialization.number(), JobPartsArray]);
